import { render, staticRenderFns } from "./groupBuyManage.vue?vue&type=template&id=598f026f&scoped=true"
import script from "./groupBuyManage.vue?vue&type=script&lang=js"
export * from "./groupBuyManage.vue?vue&type=script&lang=js"
import style0 from "./groupBuyManage.vue?vue&type=style&index=0&id=598f026f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f026f",
  null
  
)

export default component.exports